import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
import { Reveal } from './Reveal';
type QA = {
  q: string;
  a: string;
};
const faqs: QA[] = [{
  q: 'Comment fonctionne Le Protocole Clinique ?',
  a: "Vous recevez immédiatement par e-mail un lien de téléchargement donnant accès à l'ensemble du kit : 6 modules + 5 outils complémentaires en format PDF et Word éditable."
}, {
  q: "Fonctionne-t-il pour tous les niveaux d'intervention ?",
  a: 'Oui. Le kit couvre les niveaux dépistage, intervention initiale et suivi avancé pour une utilisation en cabinet libéral ou structure médico-sociale.'
}, {
  q: 'Puis-je modifier le matériel ?',
  a: "Oui. Tous les fichiers Word sont entièrement éditables et personnalisables à l'image de votre cabinet."
}, {
  q: 'Les outils complémentaires sont-ils inclus dans le prix ?',
  a: 'Oui. Les 5 outils complémentaires sont inclus gratuitement dans le pack complet à 27€.'
}, {
  q: 'Est-il adapté aux praticiens débutants ?',
  a: 'Absolument. Le système est conçu pour être utilisable dès le premier jour, quel que soit votre niveau d\u2019expérience.'
}, {
  q: 'Est-il utile pour les enseignants spécialisés ?',
  a: 'Oui. Le kit est adapté aussi bien aux professionnels en cabinet qu\u2019aux enseignants spécialisés en ULIS, SEGPA ou MDPH.'
}, {
  q: "Combien de temps dure l'accès ?",
  a: "L'accès est à vie. Une fois acheté, le kit vous appartient pour toujours."
}, {
  q: "Qu'est-ce qui différencie ce kit des autres ressources cliniques ?",
  a: "Ce kit est le seul à combiner protocoles d'intervention, supports prêts à imprimer, outils administratifs et système de suivi dans un seul pack structuré, prêt à utiliser dès aujourd'hui."
}];
function FaqItem({
  item,
  index
}: {
  item: QA;
  index: number;
}) {
  const [open, setOpen] = useState(false);
  return <Reveal delay={index % 4 * 0.04} data-id="element-64">
      <div className="overflow-hidden rounded-xl border border-ink-border bg-ink-card" data-id="element-65">
        <button type="button" onClick={() => setOpen(o => !o)} className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left" aria-expanded={open} data-id="element-66">
          <span className="flex items-center gap-3 font-semibold text-white" data-id="element-67">
            <span className="text-gold" data-id="element-68">❓</span> {item.q}
          </span>
          <ChevronDownIcon className={`h-5 w-5 shrink-0 text-white/50 transition-transform duration-200 ${open ? 'rotate-180' : ''}`} data-id="element-69" />
        </button>
        <AnimatePresence initial={false} data-id="element-70">
          {open && <motion.div initial={{
          height: 0,
          opacity: 0
        }} animate={{
          height: 'auto',
          opacity: 1
        }} exit={{
          height: 0,
          opacity: 0
        }} transition={{
          duration: 0.25,
          ease: 'easeInOut'
        }} data-id="element-71">
              <p className="px-5 pb-5 pl-12 text-sm leading-relaxed text-white/65" data-id="element-72">
                {item.a}
              </p>
            </motion.div>}
        </AnimatePresence>
      </div>
    </Reveal>;
}
export function FAQ() {
  return <section className="w-full bg-black px-4 py-20" data-id="element-73">
      <div className="mx-auto max-w-3xl" data-id="element-74">
        <Reveal data-id="element-75">
          <h2 className="text-center font-display text-3xl uppercase leading-tight text-white sm:text-4xl" data-id="element-76">
            Questions Fréquentes
          </h2>
        </Reveal>
        <div className="mt-10 space-y-3" data-id="element-77">
          {faqs.map((f, i) => <FaqItem key={f.q} item={f} index={i} data-id="element-78" />)}
        </div>
      </div>
    </section>;
}